import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { OffreEsnService } from './../../../../core/services/offre-esn/offre-esn.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

const DOMPurify = require('dompurify')

@Component({
  selector: 'app-detail-offer-candidature',
  templateUrl: './detail-offer-candidature.component.html',
  styleUrls: ['./detail-offer-candidature.component.css'],
})
export class DetailOfferCandidatureComponent {
  /* number */
  tabulation: number = 10;

  /* boolean */
  disabledMode: boolean = true;
  /* object */
  jobofferDetails: any;
  /* string */
  idEsn!: string;
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected = this.localStorageService.getData('clientConnected');

  /* formGroup */
  /* unsubscription */
  id = this.activatedRoute.snapshot.params['id'];
  iduser: any;
  private unsubscribeAll: Subject<void> = new Subject();
  listconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  selectedUserId!: string;
  skills: any;
  safeDescription!: SafeHtml;
  url: string = environment.baseUrl + '/api';
  constructor(
    private activatedRoute: ActivatedRoute,
    private offreesnservice: OffreEsnService,
    private toastrService: ToastrService,
    private route: Router,
    private jobofferservice: EsnJobOfferService,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    console.log('bienvenu!!');
    this.getjobofferById();
    this.getskillsjoboffer();
  }

  /* get job offer details */
  getjobofferById() {
    this.spinner.show();
    this.offreesnservice.getoffrecandidatureById(this.id).subscribe({
      next: (res: any) => {
        console.log('reponse', res);
        this.jobofferDetails = res.data[0];
        this.updateDescription(this.jobofferDetails?.description);
        console.log('detail job offer', this.jobofferDetails);
        this.spinner.hide();
      },
      error: () => {},
    });
  }
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
  /* get skills job offer  */
  getskillsjoboffer() {
    this.jobofferservice.getskillsjoboffre(this.id).subscribe({
      next: (res: any) => {
        this.skills = res.data;
        console.log('skills job offer', this.skills);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  retirercandidature() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.jobofferDetails.User_id,
      job_offer_id: this.jobofferDetails.id,
    };
    console.log('data', data);
    Swal.fire({
      title: 'Êtes-vous sûr de vouloir retirer cette candidature ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, retirer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.offreesnservice.retirercandidature(data).subscribe({
          next: (res: any) => {
            console.log('res', res);
            this.toastrService.success(
              'votre candidature a été retiré avec succès.'
            );
            this.route.navigateByUrl('/esn-offres-emploi/candidature');
          },
          error: (error) => {
            console.log(error);
            console.log(error.error.message);
            if (error.error.message === 'candidature already exist.') {
              this.toastrService.error('Candidature existe déjà');
            }
            if (error.error.message === 'the job offer has been deactivated.') {
              this.toastrService.error(
                "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
              );
            }
          },
        });
      }
    });
  }
}
